<p-dialog header="Session Audit" [(visible)]="isSessionAuditModalShow" [draggable]="false"
          [style]="{ width: '100vw', height: '95vh' }" (onHide)="closeSessionAuditModal()" [modal]="true"
          id="sessionAuditModal">
  <app-session-audit-trial [sessionId]="sessionId">
  </app-session-audit-trial>
</p-dialog>
